import { theme } from '@zappyrent/hundop';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Media from 'react-media';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import Header from '../../components/Layout/Header';
import Main from '../../components/Layout/Main';
import UserAvatar from '../../components/User/UserAvatar';
import {
  StyledResetPasswordButton,
  StyledResetPasswordButtonWrapper,
} from '../../components/User/UserInfoFields/UserInfoFields.styles';
import UserInfoPanel from '../../components/User/UserInfoPanel';
import UserPaymentsBankAccounts from '../../components/User/UserPayments';
import UserResetPasswordModal from '../../components/User/UserResetPasswordModal';
import { UserTransferInstructions } from '../../components/User/UserTransferInstructions';
import UserType from '../../components/User/UserType';
import { useUser } from '../../shared/hooks';
import useDisclosure from '../../shared/hooks/useDisclosure';
import useUserDocuments from '../../shared/hooks/useUserDocuments';
import useStore from '../../store';
import { StyledWrapper } from './Profile.styles';

const Profile = (): JSX.Element | null => {
  const user = useStore(state => state.user);

  const isLoadingUser = useUser();
  const isLoadingUserDocuments = useUserDocuments(user?.id ?? null);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { t } = useTranslation(['form', 'translation']);
  useEffect(() => {
    if (searchParams.get('action') === 'reset-password') {
      onOpen();
    }
  }, []);

  const handleUserResetPasswordModalOpen = () => {
    onOpen();
    navigate(`${location.pathname}?action=reset-password`);
  };

  const handleUserResetPasswordModalClose = () => {
    onClose();
    navigate(location.pathname);
  };
  return (
    <>
      {' '}
      {isOpen && (
        <UserResetPasswordModal onClose={handleUserResetPasswordModalClose} />
      )}
      {!isLoadingUser && !isLoadingUserDocuments && (
        <StyledWrapper>
          <Header />
          <Main>
            <UserAvatar />
            <UserType />
            {user?.type === 'tenant' && (
              <Media
                queries={{
                  mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
                }}
              >
                {matches => matches.mobile && <UserInfoPanel />}
              </Media>
            )}
            <br />
            {user?.type === 'landlord' && <UserPaymentsBankAccounts />}
            {user?.type === 'tenant' && <UserTransferInstructions />}
            <StyledResetPasswordButtonWrapper>
              <StyledResetPasswordButton
                user={user?.type}
                onClick={handleUserResetPasswordModalOpen}
              >
                {t('translation:resetPassword')}
              </StyledResetPasswordButton>
            </StyledResetPasswordButtonWrapper>
          </Main>
        </StyledWrapper>
      )}
    </>
  );
};

export default Profile;
